<div class="col-md-12">
  <div class="card card-container">
    <h1>{{ 'create_account' | translate }}</h1>
    <br />
    <br />
    <form
      *ngIf="!isSuccessful"
      name="form"
      (ngSubmit)="f.form.valid && onSubmit()"
      #f="ngForm"
      novalidate
    >
      <div class="form-group">
        <mat-form-field class="w-full">
          <mat-label>{{ 'username' | translate }}</mat-label>
          <input
            matInput
            id="username"
            type="text"
            name="username"
            [(ngModel)]="form.username"
            required
            minlength="3"
            maxlength="20"
            #username="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && username.errors }"
          />
        </mat-form-field>
        <div class="invalid-feedback" *ngIf="username.errors && f.submitted">
          <div *ngIf="username.errors['required']">{{ 'username_required' | translate }}</div>
          <div *ngIf="username.errors['minlength']">
            {{ 'username_minlength' | translate }}
          </div>
          <div *ngIf="username.errors['maxlength']">
            {{ 'username_maxlength' | translate }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <mat-form-field class="w-full">
          <mat-label>{{ 'email' | translate }}</mat-label>
          <input
            matInput
            type="email"
            name="email"
            [(ngModel)]="form.email"
            required
            email
            #email="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && email.errors }"
          />
        </mat-form-field>
        <div class="invalid-feedback" *ngIf="email.errors && f.submitted">
          <div *ngIf="email.errors['required']">{{ 'email_required' | translate }}</div>
          <div *ngIf="email.errors['email']">
            {{ 'email_invalid' | translate }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <mat-form-field class="w-full">
          <mat-label>{{ 'password' | translate }}</mat-label>
          <input
            matInput
            type="password"
            name="password"
            [(ngModel)]="form.password"
            required
            minlength="6"
            #password="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && password.errors }"
          />
        </mat-form-field>
        <div class="invalid-feedback" *ngIf="password.errors && f.submitted">
          <div *ngIf="password.errors['required']">{{ 'password_required' | translate }}</div>
          <div *ngIf="password.errors['minlength']">
            {{ 'password_minlength' | translate }}
          </div>
        </div>
      </div>
      <br />
      <div class="form-group">
        <button mat-raised-button class="btn btn-primary btn-block">{{ 'register' | translate }}</button>
      </div>

      <div class="alert alert-warning" *ngIf="f.submitted && isSignUpFailed">
        {{ 'signup_failed' | translate }}<br />{{ errorMessage }}
      </div>
    </form>

    <div class="alert alert-success" *ngIf="isSuccessful">
      {{ 'registration_successful' | translate }}
    </div>
  </div>
</div>
